// there cannot be empty prompts in the database, so we use this sentinel value to
// represent an empty prompt
export const EMPTY_PROMPT_SENTINEL = '__EMPTY_PROMPT__' as const;
